import { putSonarObjectUsersBulk } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../../../initiatives/summary/get';
import { updateSonarObjectReferences } from '../../_idMap/actions';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const putCoreSonarObjectsUsersBulkSlice = createPutAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Latest
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences(
					request.sonarObjectIds.map((sonarObjectId) => ({
						sonarObjectId,
						users: request.users
					}))
				)
		]
	},
	name: 'CoreSonarObjectsUsersBulk',
	receive: false,
	request: true,
	requestHandler: putSonarObjectUsersBulk
});
